import { Link } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import RoomLimitExceededModalWrapper from '../../../components/Calendar/ReservationModal/RoomLimitExceededModalWrapper'
import { is } from '../../../components/MediaQuery'
import Button from '../../../components/Template/Button'
import {
  CloseButton,
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import ModalFlex from '../../../components/Template/Modal/ModalFlex'
import useSize from '../../../hooks/useSize'

export interface IRoomLimitsExceededModalModalProps {
  open?: boolean
}

export interface IRoomLimitsExceededModalDispatch {
  close?: () => void
}

export const RoomLimitsExceededModal: FunctionComponent<
  IRoomLimitsExceededModalModalProps & IRoomLimitsExceededModalDispatch
> = ({ open, close }) => {
  const size = useSize()
  const { t } = useTranslation()
  const isDesktop = is.desktop()

  function warningMessage() {
    return t('BBO_2966_room_limit_exceeded_message')
      .split('\\n')
      .map((mes, index) => (
        <span style={{ wordBreak: 'break-all' }} key={index}>
          {mes}
        </span>
      ))
  }

  function onClose() {
    close()
  }

  function exit() {
    onClose()
  }

  return (
    <ModalFlex
      style={{ marginBottom: isDesktop ? '30vh' : 0 }}
      open={open}
      onClose={onClose}
    >
      <RoomLimitExceededModalWrapper>
        <ModalHeader
          style={{
            boxSizing: 'border-box',
            padding: `${size}em ${0.4 * size}em 0px ${1.3 * size}em`,
          }}
        >
          <Flex style={{ minWidth: '0', width: '100%' }} justifyStart={true}>
            <ModalHeaderLabel size={size}>
              <Trans i18nKey={'BBO_2966_room_limit_exceeded_title'}>
                Can't add another room in your pricing plan
              </Trans>
            </ModalHeaderLabel>
          </Flex>
          <Flex justifyEnd={true} alignCenter={true}>
            <CloseButton size={size} onClose={onClose} />
          </Flex>
        </ModalHeader>
        <Flex
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `${10 * size}px ${1.3 * size}em ${10 * size}px ${
              1.3 * size
            }em`,
          }}
        >
          {warningMessage()}
          <Link
            style={{ wordBreak: 'break-all' }}
            href={t('BBO_2966_room_limit_exceeded_link')}
            target={'_blank'}
          >
            {t('BBO_2966_room_limit_exceeded_link')}
          </Link>
        </Flex>
        <Flex
          row={true}
          style={{
            marginBottom: `${20 * size}px`,
            marginLeft: `${1.3 * size}em`,
            marginRight: `${1.3 * size}em`,
            marginTop: `${15 * size}px`,
          }}
        >
          <Button
            size={size}
            style={{ width: '100%' }}
            onClick={exit}
            primary={true}
          >
            <Trans i18nKey={'ok'} />
          </Button>
        </Flex>
      </RoomLimitExceededModalWrapper>
    </ModalFlex>
  )
}

export default RoomLimitsExceededModal
